/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preview_Noresourcesdesc2Inputs */

const zh_preview_noresourcesdesc2 = /** @type {(inputs: Preview_Noresourcesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具生成的资源（图片、音频、视频）将显示在这里。`)
};

const en_preview_noresourcesdesc2 = /** @type {(inputs: Preview_Noresourcesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resources generated by tools (images, audio, video) will appear here.`)
};

const es_preview_noresourcesdesc2 = /** @type {(inputs: Preview_Noresourcesdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los recursos generados por herramientas (imágenes, audio, video) aparecerán aquí.`)
};

/**
* | output |
* | --- |
* | "Resources generated by tools (images, audio, video) will appear here." |
*
* @param {Preview_Noresourcesdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const preview_noresourcesdesc2 = /** @type {((inputs?: Preview_Noresourcesdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preview_Noresourcesdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_preview_noresourcesdesc2(inputs)
	if (locale === "en") return en_preview_noresourcesdesc2(inputs)
	return es_preview_noresourcesdesc2(inputs)
});
export { preview_noresourcesdesc2 as "preview_noResourcesDesc" }